import { render, staticRenderFns } from "./nineConsumerList.vue?vue&type=template&id=2f4a85a2&scoped=true"
import script from "./nineConsumerList.vue?vue&type=script&lang=js"
export * from "./nineConsumerList.vue?vue&type=script&lang=js"
import style0 from "./nineConsumerList.vue?vue&type=style&index=0&id=2f4a85a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4a85a2",
  null
  
)

export default component.exports